<template>
  <div class="animated fadeIn">
    <!-- Header Premium -->
    <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
      <div class="d-flex align-items-center p-3">
        <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%);">
          <i class="fa fa-users text-white"></i>
        </div>
        <div class="header-text-container">
          <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Clientes</h4>
          <p class="text-muted mb-0 small">Gerenciamento e consulta de clientes e fornecedores</p>
        </div>
      </div>

      <div class="d-flex align-items-center flex-wrap gap-2 p-3">
          <!-- Search Pill -->
          <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
              <b-button-group class="mr-2">
                  <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                      <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                  </b-button>
                  <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                      <i class="fa fa-file-excel-o"></i>
                  </b-button>
                  <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                      <i class="fa fa-print"></i>
                  </b-button>
                  <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                      <i class="fa fa-ban"></i>
                  </b-button>
              </b-button-group>

              <div class="d-flex align-items-center px-2 border-left mr-2">
                  <b-form-input type="text" ref="edNome" v-model="nome" placeholder="Buscar por nome ou razão social..." class="border-0 bg-transparent" style="width: 250px" @keydown.enter.native="pesquisar()" />
              </div>
              <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                  <i class="fa fa-search mr-1"></i> FILTRAR
              </b-button>
          </div>

          <!-- Action Buttons -->
          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
            <i class="fa fa-plus-circle mr-2"></i>
            <span>Novo Cliente</span>
          </b-button>
      </div>
    </div>

    <!-- Advanced Filter Panel -->
    <b-collapse v-model="filtroAvancado">
        <div class="px-4 pb-4">
            <div class="card card-filter-premium p-4 border-0 shadow-sm">
                <b-row align-v="end">
                  <b-col md="4">
                    <label class="font-weight-bold text-muted small">Código</label>
                    <b-form-input type="text" v-model="id" placeholder="ID" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                  </b-col>
                  <b-col md="8">
                    <label class="font-weight-bold text-muted small">CPF / CNPJ</label>
                    <b-form-input type="text" v-model="cpf" placeholder="Somente números" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                  </b-col>
                </b-row>
            </div>
        </div>
    </b-collapse>

    <b-row class="ml-0 mr-0 p-0">
      <b-col sm="12" class="p-0">
        <b-table  
                ref="tbl"      
                id="table-transition-example"
                class="modern-premium-table"
                :primary-key="'CODIGO'"
                responsive  hover  small  show-empty
                empty-text="Nenhum cliente encontrado"
                :sticky-header="stickyHeight"
                :tbody-tr-class="rowClassSelecionado" 
                :items="itensFiltrados"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                @row-clicked="clicarLinha"
                @row-dblclicked="edit">
            <template #head(CODIGO)>
              <SetFilter
                label="ID"
                v-model="filtros.CODIGO"
                :options="opcoes.CODIGO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(NOME)>
              <SetFilter
                label="Nome"
                v-model="filtros.NOME"
                :options="opcoes.NOME"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(NOME_MUNICIPIO)>
              <SetFilter
                label="Nome Município"
                v-model="filtros.NOME_MUNICIPIO"
                :options="opcoes.NOME_MUNICIPIO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(ID_UF)>
              <SetFilter
                label="UF"
                v-model="filtros.ID_UF"
                :options="opcoes.ID_UF"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(CGC)>
              <SetFilter
                label="CPF/CNPJ"
                v-model="filtros.CGC"
                :options="opcoes.CGC"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(OP_SITUACAO_FINANCEIRO)>
              <SetFilter
                label="Financeiro"
                v-model="filtros.OP_SITUACAO_FINANCEIRO"
                :options="opcoes.OP_SITUACAO_FINANCEIRO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(ENDERECO)>
              <SetFilter
                label="Endereço"
                v-model="filtros.ENDERECO"
                :options="opcoes.ENDERECO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(STATUS)>
              <SetFilter
                label="Status"
                v-model="filtros.STATUS"
                :options="opcoes.STATUS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            
            <template #cell(CODIGO)="item">{{item.item.CODIGO}}</template>
            <template #cell(NOME)="item">{{item.item.NOME}}</template>
            <template #cell(STATUS)="item">
              <b-badge :variant="colorirStatus(item.item)" class="px-3 py-2 rounded-pill">
                {{item.item.STATUS}}
              </b-badge>
            </template>
            <template #cell(OP_SITUACAO_FINANCEIRO)="item">
              <b-badge :variant="colorirSituacao(item.item)" class="px-3 py-2 rounded-pill">
                {{traduzirSituacao(item.item)}}
              </b-badge>
            </template>
            <template #cell(CGC)="item">
              {{ formatarCnpjCpf(item.item.CGC || '') }}
            </template>
            <template #cell(tipoCadastro)="item">
              <b-badge :variant="colorirStatusTipoCliente(item.item)" class="px-3 py-2 rounded-pill">
                {{traduzirSituacaoTipoCliente(item.item)}}
              </b-badge>
            </template>
            <template #cell(actions)="item">
              <div class="d-flex justify-content-end gap-1">
                <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                  <i class="fa fa-pencil"></i>
                </b-button>
                <b-button type="button" @click.stop.prevent="details(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                  <i class="fa fa-trash"></i>
                </b-button>
              </div>
            </template>

            <template slot="bottom-row">
              <td v-for="(field, idx) in fields" :key="idx" class="bg-light font-weight-bold text-dark border-top">
                <template v-if="field.key === 'CODIGO'">
                  Total: {{ itensFiltrados.length }}
                </template>
                <template v-else></template>
              </td>
            </template>
          </b-table>
        
      </b-col>
      </b-row>
      <div>
      <!-- Modal de Confirmação para Resultados Grandes -->
      <ModalAlertaResultadoGrande
        ref="modalConfirmarResultadoGrande"
        :count="resultadoPendenteCount"
        @confirmar="confirmarCarregarResultadoGrande"
        @cancelar="cancelarCarregarResultadoGrande"
        @shown="modalConfirmacaoAberto = true"
        @hidden="modalConfirmacaoAberto = false"
      />

      <!-- Modal de Exclusão de Cliente -->
      <b-modal 
        ref="modalExcluirCliente" 
        hide-header
        hide-footer
        centered
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        @hidden="clienteAExcluir = null">
        
        <div class="modal-header-premium p-3 d-flex align-items-center bg-danger">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-trash text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Excluir Cliente</h5>
                <small class="text-white opacity-75">Esta ação não poderá ser desfeita</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modalExcluirCliente.hide()">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="mb-4" v-if="clienteAExcluir">
                <div class="alert alert-warning d-flex align-items-center">
                    <i class="fa fa-exclamation-triangle mr-2"></i>
                    <span>Confirme os dados do cliente antes de excluir</span>
                </div>
                
                <div class="card border-0 bg-light">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <small class="text-muted d-block">Código</small>
                                <strong>{{ clienteAExcluir.CODIGO }}</strong>
                            </div>
                            <div class="col-md-9">
                                <small class="text-muted d-block">Nome</small>
                                <strong>{{ clienteAExcluir.NOME }}</strong>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <small class="text-muted d-block">Razão Social</small>
                                <strong>{{ clienteAExcluir.RAZAOSOCIAL || '-' }}</strong>
                            </div>
                            <div class="col-md-6">
                                <small class="text-muted d-block">CPF/CNPJ</small>
                                <strong>{{ formatarCnpjCpf(clienteAExcluir.CGC || '') || '-' }}</strong>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-8">
                                <small class="text-muted d-block">Endereço</small>
                                <strong>{{ clienteAExcluir.ENDERECO || '-' }}</strong>
                            </div>
                            <div class="col-md-4">
                                <small class="text-muted d-block">Cidade/UF</small>
                                <strong>{{ clienteAExcluir.NOME_MUNICIPIO || '-' }} / {{ clienteAExcluir.ID_UF || '-' }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center gap-3">
                <b-button variant="outline-secondary" pill class="px-4" @click="$refs.modalExcluirCliente.hide()">
                    <i class="fa fa-ban mr-1"></i> CANCELAR
                </b-button>
                <b-button variant="danger" pill class="px-4 font-weight-bold" @click="confirmarExclusao" :disabled="excluindo">
                    <span v-if="!excluindo">
                        <i class="fa fa-trash mr-1"></i> SIM, EXCLUIR
                    </span>
                    <span v-else>
                        <i class="fa fa-spinner fa-spin mr-1"></i> EXCLUINDO...
                    </span>
                </b-button>
            </div>
            <div class="mt-3 text-center">
                <small class="text-muted">Pressione [ESC] para cancelar</small>
            </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import cSwitch from '../../../components/Switch'
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'

export default {
  components: { 
    VueButtonSpinner,
    cSwitch,
    SetFilter,
    ModalAlertaResultadoGrande
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    perPageDefault: 50,
    filters: [
      { key: 'CODIGO', type: 'number', label: 'ID' },
      { key: 'NOME', type: 'string', label: 'Nome' },
      { key: 'NOME_MUNICIPIO', type: 'string', label: 'Municipio' },
      { key: 'ID_UF', type: 'string', label: 'UF' },
      { key: 'CGC', type: 'string', label: 'CPF/CNPJ' },
      { key: 'OP_SITUACAO_FINANCEIRO', type: 'string', label: 'Financeiro',
        labelMap: { '0': 'LIBERADO', '1': 'BLOQUEADO' } },
      { key: 'ENDERECO', type: 'string', label: 'Endereço' },
      { key: 'STATUS',   type: 'string', label: 'Situação Cadastro' }
    ]
  })],
  name: 'Clientes',
  data () {
    return {
      isLoading: false,
      status: '',
      isBusy: false,
      registroSelecionadoId : null,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      clienteAExcluir: null,
      excluindo: false,
      fields: [
        {
          key: "CODIGO",
          label: 'Id',
          thStyle: { width: "5%" },
          class:'align-middle text-right',
          sortable: true
        },
        {
          key: "NOME",
          label: 'Nome', 
          thStyle: { width: "20%" },
          class:'align-middle',
          sortable: true 
        },
        {
          key: "ENDERECO",
          thStyle: { width: "15%" },
          class:'align-middle',
          label: 'Endereço', 
          sortable: true 
        },
        {
          key: "NOME_MUNICIPIO",
          label: 'Municipio',
          thStyle: { width: "10%" },
          class:'align-middle', 
          sortable: true 
        },
        {
          key: "ID_UF",
          label: 'UF', 
          thStyle: { width: "5%" },
          class:'align-middle',
          sortable: true 
        },
         {
          key: "STATUS",
          label: 'Situação', 
          thStyle: { width: "5%" },
          class:'align-middle',
          sortable: true 
        },
         {
          key: "TIPO_CONTROLE_CREDITO",
          label: 'Controle de Credito', 
          thStyle: { width: "10%" },
          class:'align-middle',
          sortable: true 
        },
         {
          key: "OP_SITUACAO_FINANCEIRO",
          thStyle: { width: "5%" },
          class:'align-middle',
          label: 'Financeiro', 
          sortable: true 
        },
        {
          key: "CGC",
          column: 'CGC',
          label: 'CPF/CNPJ',
          thStyle: { width: "10%" },
          class:'align-middle',
          sortable: true
        },
        {
          key: 'tipoCadastro', 
          label: 'Tipo Cadastro', 
          thStyle: { width: "10%" },
          class:'align-middle',
          sortable: true 
        },
        {
          key: "actions" ,
          
          label: 'Ações' ,
          thStyle: { width: "5%" },
          class:'align-middle text-right p-0',
        }
      ],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' }
    }
  },
  computed: {
    ...mapGetters('tema',{isDark: 'IS_DARK'}),
    currentPage: {
      get () {
        return this.$store.getters['cliente/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("cliente/SET_PAGINA_ATUAL", value);
      }
    },
    filtroAvancado: {
      get () {
        return this.$store.getters['cliente/FILTRO_AVANCADO']
      }, 
      set (value) {
        this.$store.commit("cliente/SET_FILTRO_AVANCADO", value);
      }
    },
    dt1: {
      get () {
        return this.$store.getters['cliente/DATA_INICIAL']
      }, 
      set (value) {
        this.$store.commit("cliente/SET_DATA_INICIAL", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['cliente/DATA_FINAL']
      }, 
      set (value) {
        this.$store.commit("cliente/SET_DATA_FINAL", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['cliente/ID']
      }, 
      set (value) {
        this.$store.commit("cliente/SET_ID", value);
      }
    },
    nome: {
      get () {
        return this.$store.getters['cliente/NOME']
      }, 
      set (value) {
        this.$store.commit("cliente/SET_NOME", value);
      }
    },
    razaoSocial: {
      get () {
        return this.$store.getters['cliente/RAZAO_SOCIAL']
      }, 
      set (value) {
        this.$store.commit("cliente/SET_RAZAOSOCIAL", value);
      }
    },
    cpf: {
      get () {
        return this.$store.getters['cliente/CPF']
      }, 
      set (value) {
        this.$store.commit("cliente/SET_CPF", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['cliente/LISTA']
      }, 
      set (value) {
        this.$store.commit("cliente/SET_LISTA", value);
      }
    },/*
    lista() {
      return this.$store.getters['cliente/LISTA']
    }*/
  },
  methods: {
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['cliente/REGISTRO_SELECIONADO_ID']
      return item.CODIGO === selId ? 'cec-row-selected' : ''
    },
    clicarLinha(item) {
      this.$store.commit("cliente/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
    },
    colorirSituacao(item) { 
      return item.OP_SITUACAO_FINANCEIRO === '0' ? 'success' : 'danger'
    },

    traduzirSituacao(item) { 
      return item.OP_SITUACAO_FINANCEIRO === '0' ? 'LIBERADO' : 'BLOQUEADO'
    },
    formatarCampo(campoTexto) {
      if (campoTexto.value.length <= 11) {
          campoTexto.value = this.mascaraCpf(campoTexto.value)
      } else {
          campoTexto.value = this.mascaraCnpj(campoTexto.value)
      }
    },
    retirarFormatacao(campoTexto) {
      // Verifica se campoTexto é nulo ou undefined
      if   ((!campoTexto) 
        || (!(campoTexto instanceof HTMLElement)) 
        || (!campoTexto.hasOwnProperty('value')) 
        || (typeof campoTexto.value !== 'string')) {
        return
      }

      // Remove formatação
      campoTexto.value = campoTexto.value.replace(/(\.|\/|\-)/g, "");
    },
    mascaraCpfCgc(item) {
      if (item.CGC && typeof item.CGC === 'string') {
        return this.formatarCnpjCpf(item.CGC)
      }
      return null
    },
    formatarCnpjCpf(texto) {
      // Remove todos os caracteres que não são números
      const numeros = texto.replace(/\D/g, '');

      // Verifica se é CNPJ (14 dígitos) ou CPF (11 dígitos)
      const cnpjCpfFormatado = numeros.length === 14 ?
        numeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : // CNPJ
        numeros.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4'); // CPF

      return cnpjCpfFormatado;
    },
    colorirStatus(item) { 
      if (item.STATUS == 'ATIVO') return 'success'
      else 'danger'
    },
    colorirStatusTipoCliente(linha) { 
      let cliente = '0'
      let fornecedor = '0'
      if (linha.OP_CLIENTE && typeof linha.OP_CLIENTE === 'string') {
          cliente = linha.OP_CLIENTE.trim()
      }

      if (linha.OP_FORNECEDOR && typeof linha.OP_FORNECEDOR === 'string') {
          fornecedor = linha.OP_FORNECEDOR.trim()
      }

      if (cliente == '1' && fornecedor == '0') return 'success'
      else if (cliente == '0' && fornecedor == '1') return 'info'
      else if (cliente == '1' && fornecedor == '1') return 'gray-300'
      else 'info'
    },
    traduzirSituacaoTipoCliente(linha) { 
      let cliente = '0'
      let fornecedor = '0'
      if (linha.OP_CLIENTE && typeof linha.OP_CLIENTE === 'string') {
          cliente = linha.OP_CLIENTE.trim()
      }

      if (linha.OP_FORNECEDOR && typeof linha.OP_FORNECEDOR === 'string') {
          fornecedor = linha.OP_FORNECEDOR.trim()
      }

      if (cliente == '1' && fornecedor == '0') return 'CLIENTE'
      else if (cliente == '0' && fornecedor == '1') return 'FORNECEDOR'
      else if (cliente == '1' && fornecedor == '1') return 'CLIENTE/FORNECEDOR'
      else return ''
    },
    traduzirIsento(linha) {
      if (linha.ISENTO_ICMS && typeof linha.ISENTO_ICMS === 'string') {
        if (linha.ISENTO_ICMS.trim() == '0'|| linha.ISENTO_ICMS.trim() == '' ) return 'ISENTO'
        else if (linha.ISENTO_ICMS.trim() == '1') return 'SUJEITO'
      }
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        reportTitle: 'Listagem de Clientes',
        printedBy: window.localStorage.getItem('login') ?? '—',
        columns: this.fields,
        filename: 'clientes.html',
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'clientes.xlsx',
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'clientes.csv',
      });
    },
    limparFiltro() {
      this.$store.commit("cliente/SET_LIMPAR", null);
    },
    edit (item) {
      this.$store.commit("cliente/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
      this.$router.push(`/cadastros/clientes/edit/${item.CODIGO}`)
    },
    novo () {
      this.$router.push(`/cadastros/clientes/novo`)
    },
    details(item) {
      this.clienteAExcluir = item
      this.$refs.modalExcluirCliente.show()
    },
    async confirmarExclusao() {
      if (!this.clienteAExcluir || !this.clienteAExcluir.CODIGO) {
        return
      }

      this.excluindo = true
      
      try {
        await this.$store.dispatch('cliente/DELETE_CLIENTE', this.clienteAExcluir.CODIGO)
        
        Tools.exibirMensagem(
          this.$store, 
          'Sucesso', 
          'success', 
          'Cliente excluído com sucesso!'
        )
        
        // Fecha o modal
        this.$refs.modalExcluirCliente.hide()
        
        // Atualiza a listagem
        await this.pesquisar()
        
      } catch (err) {
        const mensagemErro = err.response?.data?.mensagem || err.message || 'Erro ao excluir o cliente'
        Tools.exibirMensagem(
          this.$store, 
          'Erro', 
          'danger', 
          mensagemErro
        )
      } finally {
        this.excluindo = false
      }
    },
    async pesquisar (ctx) {
      // Previne pesquisa se o modal de confirmação estiver aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      try {
        const resultado = await this.$store.dispatch('cliente/GET_LISTA')
        
        // Verifica se precisa de confirmação
        if (resultado.needsConfirmation) {
          // Fecha o aguardando antes de exibir o modal
          this.$store.commit('controle/setAguardando', false)
          
          // Armazena os dados para uso posterior
          this.resultadoPendente = resultado.data
          this.resultadoPendenteCount = resultado.count
          
          // Remove o foco do input antes de abrir o modal
          if (this.$refs.edNome) {
            this.$refs.edNome.blur()
          }
          
          // Exibe o modal de confirmação
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
        // Resultado carregado normalmente
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao pesquisar os registros: ' + err.message)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.$nextTick(() => {
          this.$refs.edNome?.focus()
        })
      }

    },
    async confirmarCarregarResultadoGrande() {
      // Reabre o aguardando
      this.$store.commit('controle/setAguardando', true)
      
      try {
        // Carrega os dados que estavam pendentes, pulando a confirmação
        await this.$store.dispatch('cliente/GET_LISTA', { skipConfirmation: true })
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao carregar os registros: ' + err.message)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
        this.$nextTick(() => {
          this.$refs.edNome?.focus()
        })
      }
    },
    cancelarCarregarResultadoGrande() {
      // Limpa os dados pendentes
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Pesquisa cancelada. Refine os filtros para reduzir o resultado.')
      this.$nextTick(() => {
        this.$refs.edNome?.focus()
      })
    },
    handleKeydown(event) {
      // Não executa ações se o modal estiver aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.novo()
      } else if (event.key === "Enter") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.pesquisar()
      } 
    }
  },
  created() {
    
  },
  mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      this.$store.commit('controle/setAguardando', false)
      document.addEventListener("keydown", this.handleKeydown)
      this.registroSelecionadoId = this.$store.getters['cliente/REGISTRO_SELECIONADO_ID'] ? parseInt(this.$store.getters['cliente/REGISTRO_SELECIONADO_ID']) : null
      
    }, 200)
    this.$nextTick(() => {
      this.$refs.edNome?.focus()
    })
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
  },
}
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/views/cadastros/clientes/Clientes.vue